// extracted by mini-css-extract-plugin
module.exports = {"Excursions":"style_Excursions__1R8Pw"};